import React, {FC, ReactNode} from "react";
import ModalWrapper from "../../components/Modal/ModalWrapper/ModalWrapper";
import '../../styles/components/_create-profile-model.scss'

export type CreateProfileModalPropos = {
    isOpen: boolean,
    title: string | ReactNode,
    content: string | ReactNode,
    showCloseButton?: boolean,
    onRequestClose?: () => void;
    onClickClientConfirm: () => void,
    onClickProspectConfirm: () => void,
    onClickSampleConfirm: () => void,
    size?: string
}

const CreateProfileModal: FC<CreateProfileModalPropos> = ({
                                                              isOpen = false,
                                                              title,
                                                              content,
                                                              onRequestClose,
                                                              onClickClientConfirm,
                                                              onClickProspectConfirm,
                                                              onClickSampleConfirm,
                                                              showCloseButton,
                                                              size = 'small'
                                                          }) => (
    <ModalWrapper
        id="discard-changes-modal"
        isOpen={isOpen}
        headerText={title}
        size={size}
        showCloseButton={showCloseButton}
        onRequestClose={onRequestClose}
        buttons={[
            {
                text: (
                    <div className="button-content">
                        <span>
                            <span><b>Client</b></span>
                        <br/>
                        <small className="sub-text-for-custom-modal">A profile for a client that has an active account at Northern Trust and an active profile in Partner Workstation.</small>
                        </span>
                        <span className="chevron-icon">›</span>
                    </div>
                ),
                onClick: onClickClientConfirm,
                destructive: false,
                primary: false,
                className: 'button-client'
            },
            {
                text: (
                    <div className="button-content">
                        <span>
                            <span><b>Prospect</b></span>
                        <br/>
                        <small className="sub-text-for-custom-modal">A profile for an individual or organization that has an active prospect profile in Partner Workstation, but does not have accounts at Northern Trust.</small>
                        </span>
                        <span className="chevron-icon">›</span>
                    </div>
                ),
                onClick: onClickProspectConfirm,
                destructive: false,
                primary: false,
                className: 'button-prospect'
            },
            {
                text: (
                    <div className="button-content">
                        <span>
                         <span><b>Sample</b></span>
                         <br/>
                         <small className="sub-text-for-custom-modal">An example persona profile intended for training and demonstration purposes.</small>
                        </span>
                        <span className="chevron-icon">›</span>
                    </div>
                ),
                onClick: onClickSampleConfirm,
                destructive: false,
                primary: false,
                className: 'button-sample'
            }
        ]}
    >
        <div className="font-md">{content}</div>
    </ModalWrapper>
);

export default CreateProfileModal;
